import { EyeOutlined } from '@ant-design/icons';
import { offerStatuses } from '@features/offers/constants/offerStatuses.const';
import { Button, Drawer, Table, Tag } from 'antd';

import { Offer } from 'src/features/offers/interfaces/offersInterface';
import { renderOfferNameWithTags } from 'src/features/offers/utils/renderOfferNameWithTags';

const colorByStatus = {
  active: 'green',
  expired: 'magenta',
  scheduled: 'orange',
};

export interface ManageFlowDrawerProps {
  isOpen: boolean;
  isLoading: boolean;
  flowOffers?: {
    offers: Offer[];
  };
  onOpenOffer: (offerId: number, productId: number) => void;
  onClose: () => void;
}
export const ManageFlowDrawer = ({
  isOpen,
  isLoading,
  onClose,
  flowOffers,
  onOpenOffer,
}: ManageFlowDrawerProps) => {
  return (
    <Drawer
      width={'60%'}
      title='Ofertas vinculadas ao funil'
      placement='right'
      onClose={onClose}
      open={isOpen}
      maskClosable={false}
    >
      <Table
        loading={isLoading}
        dataSource={flowOffers?.offers || []}
        pagination={false}
        rowKey='id'
        columns={[
          {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            width: '60px',
          },
          {
            title: 'Nome',
            dataIndex: 'name',
            key: 'name',
            render: (name: string, offer: Offer) =>
              renderOfferNameWithTags(name, offer),
          },
          {
            title: 'Produto',
            dataIndex: 'productSellGroups',
            key: 'productSellGroups',
            render: (productSellGroups: Offer['productSellGroups']) => {
              if (!productSellGroups) return '-';

              return `${productSellGroups.id} - ${productSellGroups.name}`;
            },
          },
          {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (status: Offer['status']) => {
              if (!status) return '-';

              return (
                <Tag color={colorByStatus[status]}>
                  {offerStatuses[status]}
                </Tag>
              );
            },
          },
          {
            title: 'Ações',
            dataIndex: 'actions',
            key: 'actions',
            width: '60px',
            render: (_: string, record: Offer) => {
              return (
                <Button
                  type='text'
                  disabled={!record.productSellGroupId}
                  onClick={() => {
                    onOpenOffer(
                      Number(record.id),
                      Number(record.productSellGroupId)
                    );
                  }}
                  icon={<EyeOutlined />}
                />
              );
            },
          },
        ]}
      />
    </Drawer>
  );
};
